"use client";

import Link from "next/link";
import { motion } from "framer-motion";

const securityPoints = [
  {
    icon: "encrypted",
    title: "Encrypted by Default",
    description: "All data encrypted in transit and at rest using banking-grade standards.",
  },
  {
    icon: "shield_person",
    title: "Model Privacy",
    description: "Client data is never used to train AI models or shared with third parties.",
  },
  {
    icon: "lock",
    title: "Data Ownership",
    description: "You own your data completely. Export or delete your records at any time.",
  },
];

export function SecuritySection() {
  return (
    <section className="py-20 sm:py-32 px-4 sm:px-8 bg-landing-text">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-serif font-bold tracking-tight text-white">
            Your data stays yours.
          </h2>
        </motion.div>
        <div className="grid md:grid-cols-3 gap-8">
          {securityPoints.map((point, i) => (
            <motion.div
              key={point.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.6 }}
              className="group p-8 rounded-3xl bg-white/5 border border-white/10 hover:-translate-y-2 transition-all duration-300 hover:bg-white/10"
            >
              <div className="mb-6">
                <span className="material-symbols-outlined text-3xl text-landing-primary">
                  {point.icon}
                </span>
              </div>
              <h3 className="text-xl font-bold mb-3 text-white">{point.title}</h3>
              <p className="text-landing-surface leading-relaxed">{point.description}</p>
            </motion.div>
          ))}
        </div>
        <div className="text-center mt-12">
          <Link
            href="/security"
            className="text-white/60 hover:text-white transition-colors text-sm font-medium"
          >
            Learn more about our security →
          </Link>
        </div>
      </div>
    </section>
  );
}
